"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.plural_fr = exports.plural_en = exports.escape = void 0;
var escape = exports.escape = function () {
  var MAP = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&#34;',
    "'": '&#39;'
  };
  var repl = function repl(c) {
    return MAP[c];
  };
  return function (s) {
    return s.replace(/[&<>'"]/g, repl);
  };
}();
var plural_en = exports.plural_en = function plural_en(value, s, p) {
  if (value == 1) return s;
  return p;
};
var plural_fr = exports.plural_fr = function plural_fr(value, s, p) {
  if (value == 1 || value == 0) return s;
  return p;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJlc2NhcGUiLCJleHBvcnRzIiwiTUFQIiwicmVwbCIsImMiLCJzIiwicmVwbGFjZSIsInBsdXJhbF9lbiIsInZhbHVlIiwicCIsInBsdXJhbF9mciJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sb2NhbGUvdXRpbHMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHZhciBlc2NhcGUgPSAoZnVuY3Rpb24gKCkge1xuICAgIHZhciBNQVAgPSB7XG4gICAgICAgICcmJzogJyZhbXA7JyxcbiAgICAgICAgJzwnOiAnJmx0OycsXG4gICAgICAgICc+JzogJyZndDsnLFxuICAgICAgICAnXCInOiAnJiMzNDsnLFxuICAgICAgICBcIidcIjogJyYjMzk7J1xuICAgIH07XG5cbiAgICB2YXIgcmVwbCA9IGZ1bmN0aW9uIChjKSB7XG4gICAgICAgIHJldHVybiBNQVBbY107XG4gICAgfTtcblxuICAgIHJldHVybiBmdW5jdGlvbiAocykge1xuICAgICAgICByZXR1cm4gcy5yZXBsYWNlKC9bJjw+J1wiXS9nLCByZXBsKTtcbiAgICB9O1xufSkoKTtcblxuZXhwb3J0IHZhciBwbHVyYWxfZW4gPSBmdW5jdGlvbih2YWx1ZSwgcywgcCkge1xuICAgIGlmICh2YWx1ZSA9PSAxKSByZXR1cm4gcztcbiAgICByZXR1cm4gcDtcbn07XG5cbmV4cG9ydCB2YXIgcGx1cmFsX2ZyID0gZnVuY3Rpb24odmFsdWUsIHMsIHApIHtcbiAgICBpZiAodmFsdWUgPT0gMSB8fCB2YWx1ZSA9PSAwKSAgcmV0dXJuIHM7XG4gICAgcmV0dXJuIHA7XG59OyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sSUFBSUEsTUFBTSxHQUFBQyxPQUFBLENBQUFELE1BQUEsR0FBSSxZQUFZO0VBQzdCLElBQUlFLEdBQUcsR0FBRztJQUNOLEdBQUcsRUFBRSxPQUFPO0lBQ1osR0FBRyxFQUFFLE1BQU07SUFDWCxHQUFHLEVBQUUsTUFBTTtJQUNYLEdBQUcsRUFBRSxPQUFPO0lBQ1osR0FBRyxFQUFFO0VBQ1QsQ0FBQztFQUVELElBQUlDLElBQUksR0FBRyxTQUFQQSxJQUFJQSxDQUFhQyxDQUFDLEVBQUU7SUFDcEIsT0FBT0YsR0FBRyxDQUFDRSxDQUFDLENBQUM7RUFDakIsQ0FBQztFQUVELE9BQU8sVUFBVUMsQ0FBQyxFQUFFO0lBQ2hCLE9BQU9BLENBQUMsQ0FBQ0MsT0FBTyxDQUFDLFVBQVUsRUFBRUgsSUFBSSxDQUFDO0VBQ3RDLENBQUM7QUFDTCxDQUFDLENBQUUsQ0FBQztBQUVHLElBQUlJLFNBQVMsR0FBQU4sT0FBQSxDQUFBTSxTQUFBLEdBQUcsU0FBWkEsU0FBU0EsQ0FBWUMsS0FBSyxFQUFFSCxDQUFDLEVBQUVJLENBQUMsRUFBRTtFQUN6QyxJQUFJRCxLQUFLLElBQUksQ0FBQyxFQUFFLE9BQU9ILENBQUM7RUFDeEIsT0FBT0ksQ0FBQztBQUNaLENBQUM7QUFFTSxJQUFJQyxTQUFTLEdBQUFULE9BQUEsQ0FBQVMsU0FBQSxHQUFHLFNBQVpBLFNBQVNBLENBQVlGLEtBQUssRUFBRUgsQ0FBQyxFQUFFSSxDQUFDLEVBQUU7RUFDekMsSUFBSUQsS0FBSyxJQUFJLENBQUMsSUFBSUEsS0FBSyxJQUFJLENBQUMsRUFBRyxPQUFPSCxDQUFDO0VBQ3ZDLE9BQU9JLENBQUM7QUFDWixDQUFDIiwiaWdub3JlTGlzdCI6W119


//////////////////
// WEBPACK FOOTER
// ./node_modules/pm-js/build/locale/utils.js
// module id = ./node_modules/pm-js/build/locale/utils.js
// module chunks = main